﻿(function() {
    "use strict";

    let app = angular.module("app");

    app.service("scrollingHelper", ScrollingHelper);

    ScrollingHelper.$inject = ["$timeout", "constants", "auth", "$rootScope"];

    function ScrollingHelper($timeout, constants, auth, $rootScope) {
        var exports = {
            init: init,
            resetSearch: resetSearch,
            loadData: loadData,
            removeMessages: removeMessages
        },
            limit = constants.pagination.limit,
            page = 1,
            currentScrollTop = 0;

        function init(vm, scrollListId) {
            $(scrollListId).scroll(function() {
                if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 1) {
                    if (!$(".loadingMoreData").length && !$(".noMoreDataToLoad").length) {
                        $(scrollListId).append($("<option class='loadingMoreData' label='Loading...'></option>").fadeIn('slow'));
                        page++;
                        loadData(vm, scrollListId, page, false);
                    }
                }
                currentScrollTop = $(scrollListId).scrollTop();
            });
            // $(scrollListId).bind("DOMSubtreeModified", function() {
            //     $(scrollListId).scrollTop(currentScrollTop);
            // });
            const scrollListElement = $(scrollListId)
            new MutationObserver(() => {
                scrollListElement.scrollTop(currentScrollTop)
            }).observe(scrollListElement[0], { subtree: true, childList: true })
        }

        function removeMessages() {
            if ($(".noMoreDataToLoad").length) {
                $(".noMoreDataToLoad").fadeOut('fast', function() {
                    $(this).remove();
                });
            }
            if ($(".loadingMoreData").length) {
                $(".loadingMoreData").fadeOut('fast', function() {
                    $(this).remove();
                });
            }
        }

        function resetSearch(vm) {
            removeMessages();
            vm.searchCustomers = undefined;
            page = 1;
        }

        function loadData(vm, scrollListId, pageNumber = 1, overwriteResult = true) {
            var requestData = {
                'page': pageNumber,
                'limit': limit,
                'search': vm.searchCustomers,
            };
            $.ajax({
                'url': $rootScope.apiEndpoint + '/customers',
                'type': 'GET',
                'data': requestData,
                'headers': auth.headers(),
                'success': function(data) {
                    $(".loadingMoreData").fadeOut('fast', function() {
                        $(this).remove();
                    });

                    if (overwriteResult) {
                        page = 1;
                        vm.customers = data.items;
                        $(scrollListId).scrollTop(0);
                    } else {
                        Array.prototype.push.apply(vm.customers, data.items);
                    }

                    if (!data.items.length && !$(".noMoreDataToLoad").length) {
                        var displayMessage = "End of results";
                        if (vm.searchCustomers && overwriteResult) displayMessage = "No matches. Try a different search";
                        $(scrollListId).append($("<option class='noMoreDataToLoad' label='" + displayMessage + "'></option>").fadeIn('slow'));
                    }

                    $timeout(function() {
                    });
                },
                'error': function() {
                    alert('There was an error loading the data');
                }
            });
        }

        return exports;
    }
})();
